import httpClient from '@/util/http'
import tools from '@/util/tools'
import ElementUI from 'element-ui'
import Vue from 'vue'

//用户登录
export const account_login_request = async payload => {
    try {
		let res = await httpClient.post('/accounts/login', payload);
		return res.data;
	} catch (e) {
        return Promise.reject(e);
	}
};

//用户退出
export const account_logout_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/logout', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//密码重置
export const account_resetPwd_request = async payload => {
    try {
        let res = await httpClient.post('/accounts/resetPwd', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//修改密码
export const account_updatePwd_request = async payload => {
    try {
        let res = await httpClient.put('/accounts/updatePwd', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//联系管理员
export const account_contactAdministrator_request = async payload => {
    try {
        let res = await httpClient.post('/accounts/contactAdministrator', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//忘记密码
export const account_forgetPwd_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/forgetPwd',  {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//用户列表
export const account_list_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/findAccountInfoPage', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//增加用户 
export const account_add_request = async payload => {
    try {
        let res = await httpClient.post('/accounts/addAccount', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//用户-下载导入模版
export const accounts_getImportTemplate_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/download/template',{params:payload,responseType:'arraybuffer',timeout:0});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//用户-批量导入 
export const accounts_batchImport_request = async payload => {
    try {
        let res = await httpClient.post('/accounts/upload', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//更新用户 
export const account_update_request = async payload => {
    try {
        let res = await httpClient.post('/accounts/updateAccount', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//删除用户 
export const account_remove_request = async payload => {
    try {
        let res = await httpClient.post('/accounts/removeAccount', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取用户权限等级列表
export const account_getAccountRoleList_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/findAccountRoleList', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取用户简要列表
export const account_getShortAcountList_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/getShortAcountList', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取担保人简称列表
export const account_getWarrantAcountList_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/getWarrantAcountList', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//用户-数据导出
export const account_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/exportAccountInfoList',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取地区列表
export const account_getRegionAreaList_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/getRegionAreaList', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//当前告警列表
export const currentAlarm_list_request = async payload => {
    try {
        let res = await httpClient.get('/alarm/findCurrentAlarmPage', { params:payload });
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//当前告警列表-DEMO
export const demo_currentAlarm_list_request = async payload => {
    try {
        let res = await httpClient.get('/alarm/findCurrentAlarmPage/demo', { params:payload });
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//当前告警归档 
export const currentAlarm_updateAlarmState_request = async payload => {
    try {
        let res = await httpClient.post('/alarm/updateAlarmState', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//告警确认已读 
export const currentAlarm_updateAlarmRead_request = async payload => {
    try {
        let res = await httpClient.post('/alarm/updateAlarmRead', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//未读消息数 
export const currentAlarm_countAlarmUnRead_request = async payload => {
    try {
        let res = await httpClient.get('/alarm/countAlarmUnRead', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//当前告警-数据导出
export const currentAlarm_exportCurrentAlarmList_request = async payload => {
    try {
        let res = await httpClient.get('/alarm/exportCurrentAlarmList',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-A组报表-选择单个项目-报表1
export const report_countAlarmReportAOne_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportAOne', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-A组报表-选择单个项目-报表2
export const report_countAlarmReportATwo_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportATwo', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-A组报表-选择单个项目-报表3
export const report_countAlarmReportAThree_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportAThree', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-A组报表-分页查看数据
export const report_findAlarmPageByReportA_request = async payload => {
    try {
        let res = await httpClient.get('/report/findAlarmPageByReportA', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-B组报表-选择多个项目-报表1
export const report_countAlarmReportBOne_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportBOne', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-B组报表-选择单个项目-报表2
export const report_countAlarmReportBTwo_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportBTwo', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-B组报表-选择单个项目-报表3
export const report_countAlarmReportBThree_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportBThree', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-B组报表-分页查看数据
export const report_findAlarmPageByReportB_request = async payload => {
    try {
        let res = await httpClient.get('/report/findAlarmPageByReportB', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-C组报表-选择小组维度-报表1
export const report_countAlarmReportCOne_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportCOne', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-C组报表-选择小组维度-报表2
export const report_countAlarmReportCTwo_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportCTwo', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-C组报表-选择小组维度-报表3
export const report_countAlarmReportCThree_request = async payload => {
    try {
        let res = await httpClient.get('/report/countAlarmReportCThree', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-C组报表-分页查看数据
export const report_findAlarmPageByReportC_request = async payload => {
    try {
        let res = await httpClient.get('/report/findAlarmPageByReportC', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-列表数据
export const historyAlarm_list_request = async payload => {
    try {
        let res = await httpClient.get('/alarm/findHistoryAlarmPage', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//历史数据-列表数据-数据导出
export const historyAlarm_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/alarm/exportHistoryAlarmList',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//业务组简要列表
export const bussiessGroupBriefList_request = async payload => {
    try {
        let res = await httpClient.get('/bussiessGroup/getShortBussiessGroupList', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取业务组ID获取业务组信息
export const getBussiessGroupById_request = async payload => {
    try {
        let res = await httpClient.get('/bussiessGroup/getBussiessGroupById/'+payload.bussiessGroupId,{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//业务组详细列表
export const bussiessGroup_detailList_request = async payload => {
    try {
        let res = await httpClient.get('/bussiessGroup/findBussiessGroupInfoPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//增加业务组 
export const bussiessGroup_add_request = async payload => {
    try {
        let res = await httpClient.post('/bussiessGroup/addBussiessGroup', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//更新业务组 
export const bussiessGroup_update_request = async payload => {
    try {
        let res = await httpClient.post('/bussiessGroup/updateBussiessGroup', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//删除业务组 
export const bussiessGroup_remove_request = async payload => {
    try {
        let res = await httpClient.post('/bussiessGroup/removeBussiessGroup', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//业务组-数据导出
export const bussiessGroup_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/bussiessGroup/exportBussiessGroupInfoList',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//业务组-下载导入模版
export const bussiessGroup_getImportTemplate_request = async payload => {
    try {
        let res = await httpClient.get('/bussiessGroup/download/template',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//业务组-批量导入 
export const bussiessGroup_batchImport_request = async payload => {
    try {
        let res = await httpClient.post('/bussiessGroup/upload', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//项目简要列表
export const project_briefList_request = async payload => {
    try {
        let res = await httpClient.get('/project/getProjectList',  {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//根据用户获取项目简要列表
export const project_findByAccountIdList_request = async payload => {
    try {
        let res = await httpClient.get('/project/findProjectByAccountIdList',  {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取用户管理项目列表
export const project_findProjectListByAccountId_request = async payload => {
    try {
        let res = await httpClient.get('/project/findProjectListByAccountId',  {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//项目详细列表
export const project_detailList_request = async payload => {
    try {
        let res = await httpClient.get('/project/findProjectInfoPage', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//增加项目
export const project_add_request = async payload => {
    try {
        let res = await httpClient.post('/project/addProject', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//项目-下载导入模版
export const project_getImportTemplate_request = async payload => {
    try {
        let res = await httpClient.get('/project/download/template',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//项目-批量导入 
export const project_batchImport_request = async payload => {
    try {
        let res = await httpClient.post('project/upload', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//更新项目 
export const project_update_request = async payload => {
    try {
        let res = await httpClient.post('/project/updateProject', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//删除项目 
export const project_remove_request = async payload => {
    try {
        let res = await httpClient.post('/project/removeProject', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//项目-数据导出
export const project_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/project/exportProjectInfoList',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取可关联项目用户简要列表
export const project_getProjectAcountAble_request = async payload => {
    try {
        let res = await httpClient.get('/project/getProjectAcountAble', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取项目对接系统列表
export const project_getProjectSysCodeList_request = async payload => {
    try {
        let res = await httpClient.get('/project/getProjectSysCodeList/'+payload.projectId);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取业态列表
export const project_getBusinessTypeList_request = async payload => {
    try {
        let res = await httpClient.get('/project/findBusinessTypeList',{params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取警告模式信息
export const pushManage_fetchPushModel_request = async payload => {
    try {
        let res = await httpClient.get('/push/findPushModel', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//设置警告模式 
export const pushManage_setPushModel_request = async payload => {
    try {
        let res = await httpClient.post('/push/setPushModel', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取对接系统列表
export const system_getSysSourceList_request = async payload => {
    try {
        let res = await httpClient.get('/sys/getSysSourceList', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取大区列表
export const getRegionList = async payload => {
    try {
        let res = await httpClient.get('/accounts/findRegionList', {params: payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点表-分页列表
export const assetsManage_ba_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/ba/findPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-保存或更新
export const assetsManage_ba_saveOrUpdate_request = async payload => {
    try {
        let res = await httpClient.post('/ba/saveOrUpdate', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-删除 
export const assetsManage_ba_batchRemove_request = async payload => {
    try {
        let res = await httpClient.post('/ba/removeBatchByDeviceIds', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-数据导出
export const assetsManage_ba_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/ba/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-下载导入模版
export const assetsManage_ba_getImportTemplate_request = async payload => {
    try {
        let res = await httpClient.get('/ba/download/template',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-批量导入 
export const assetsManage_ba_batchImport_request = async payload => {
    try {
        let res = await httpClient.post('/ba/upload', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-查看配置
export const assetsManage_ba_findInfoByDeviceId_request = async payload => {
    try {
        let res = await httpClient.get('/ba/findInfoByDeviceId/'+payload.deviceId);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-屏蔽告警
export const assetsManage_ba_setAlarmPolicy_request = async payload => {
    try {
        //{alarmPolicyQo:payload.alarmPolicyQo}
        let res = await httpClient.post('/ba/setAlarmPolicy/'+payload.deviceId, payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-配置
export const assetsManage_ba_setAlarmStatusRule_request = async payload => {
    try {
        let res = await httpClient.post('/ba/setAlarmStatusRule/'+payload.deviceId, payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-获取专业系统
export const assetsManage_ba_getSysAppList_request = async payload => {
    try {
        let res = await httpClient.get('/ba/getSysAppList/', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-BA点-获取数据类型列表(key与name)
export const assetsManage_ba_getValueTypeList_request = async payload => {
    try {
        let res = await httpClient.get('/ba/getValueTypeList/', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-FAS点表-数据导出
export const assetsManage_fas_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/fas/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-FAS点表-下载导入模版
export const assetsManage_fas_getImportTemplate_request = async payload => {
    try {
        let res = await httpClient.get('/fas/download/template',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-FAS点表-批量导入 
export const assetsManage_fas_batchImport_request = async payload => {
    try {
        let res = await httpClient.post('/fas/upload', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-FAS点表-查看配置
export const assetsManage_fas_findInfoByDeviceId_request = async payload => {
    try {
        let res = await httpClient.get('/fas/findInfoByDeviceId/'+payload.deviceId);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-FAS点表-获取专业系统
export const assetsManage_fas_getSysAppList_request = async payload => {
    try {
        let res = await httpClient.get('/fas/getSysAppList/', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-FAS点表-保存或更新
export const assetsManage_fas_saveOrUpdate_request = async payload => {
    try {
        let res = await httpClient.post('/fas/saveOrUpdate', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-FAS点表-分页列表
export const assetsManage_fas_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/fas/findPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-FAS点表-删除 
export const assetsManage_fas_batchRemove_request = async payload => {
    try {
        let res = await httpClient.post('/fas/removeBatchByDeviceIds', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-分页列表
export const assetsManage_terminal_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/terminal/findPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-保存或更新
export const assetsManage_terminal_saveOrUpdate_request = async payload => {
    try {
        let res = await httpClient.post('/terminal/saveOrUpdate', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-删除 
export const assetsManage_terminal_batchRemove_request = async payload => {
    try {
        let res = await httpClient.post('/terminal/removeBatchByDeviceIds', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-数据导出
export const assetsManage_terminal_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/terminal/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-下载导入模版
export const assetsManage_terminal_getImportTemplate_request = async payload => {
    try {
        let res = await httpClient.get('/terminal/download/template',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-批量导入 
export const assetsManage_terminal_batchImport_request = async payload => {
    try {
        let res = await httpClient.post('/terminal/upload', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-查看配置
export const assetsManage_terminal_findInfoByDeviceId_request = async payload => {
    try {
        let res = await httpClient.get('/terminal/findInfoByDeviceId/'+payload.deviceId);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-屏蔽告警
export const assetsManage_terminal_setAlarmPolicy_request = async payload => {
    try {
        let res = await httpClient.post('/terminal/setAlarmPolicy/'+payload.deviceId, payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-设置
export const assetsManage_terminal_setAlarmStatusRule_request = async payload => {
    try {
        let res = await httpClient.post('/terminal/setAlarmStatusRule/'+payload.deviceId, payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-获取专业系统
export const assetsManage_terminal_getSysAppList_request = async payload => {
    try {
        let res = await httpClient.get('/terminal/getSysAppList/', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//资产管理-传感器点表-获取传感器类型(key与name)
export const assetsManage_terminal_getDeviceModelList_request = async payload => {
    try {
        let res = await httpClient.get('/terminal/getDeviceModelList/', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//常规数据-数据导出
export const normalData_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/normalData/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//常规数据-分页列表
export const normalData_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/normalData/findNormalDataPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//常规数据-获取传感器类型(key与name)
export const normalData_getTypeList_request = async payload => {
    try {
        let res = await httpClient.get('/normalData/getTypeList', {params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//消防数据记录-数据导出
export const fasData_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/fasData/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//消防数据记录-分页列表
export const fasData_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/fasData/findFasDataPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//能源表-数据导出
export const meterReadReport_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/meterReadReport/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//能源表-分页列表
export const meterReadReport_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/meterReadReport/findReportMeterReadPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//抄表终端-数据导出
export const meterRead_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/meterRead/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//抄表终端-下载导入模版
export const meterRead_getImportTemplate_request = async payload => {
    try {
        let res = await httpClient.get('/meterRead/download/template',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//抄表终端-批量导入 
export const meterRead_batchImport_request = async payload => {
    try {
        let res = await httpClient.post('/meterRead/upload', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//抄表终端-保存或更新
export const meterRead_saveOrUpdate_request = async payload => {
    try {
        let res = await httpClient.post('/meterRead/saveOrUpdate', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//抄表终端-分页列表
export const meterRead_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/meterRead/findPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//抄表终端-删除 
export const meterRead_batchRemove_request = async payload => {
    try {
        let res = await httpClient.post('/meterRead/removeBatchByDeviceIds', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//抄表终端-获取终端设备型号列表(取value)
export const meterRead_getMeterReadModelList_request = async payload => {
    try {
        let res = await httpClient.post('/meterRead/getMeterReadModelList', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//抄表终端-根据ID获取信息
export const meterRead_findInfoByDeviceId_request = async payload => {
    try {
        let res = await httpClient.get('/meterRead/findInfoByDeviceId/'+payload.deviceId);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-获取配置参数接口
export const acquire_getAcquireParam_request = async payload => {
    try {
        let res = await httpClient.post('/acquire/getAcquireParam/'+payload.deviceId,payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-配置参数接口
export const acquire_configAcquireParam_request = async payload => {
    try {
        let res = await httpClient.post('/acquire/configAcquireParam/'+payload.deviceId,payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-数据导出
export const acquire_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/acquire/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-下载导入模版
export const acquire_getImportTemplate_request = async payload => {
    try {
        let res = await httpClient.get('/acquire/download/template',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-批量导入 
export const acquire_batchImport_request = async payload => {
    try {
        let res = await httpClient.post('/acquire/upload', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-保存或更新
export const acquire_saveOrUpdate_request = async payload => {
    try {
        let res = await httpClient.post('/acquire/saveOrUpdate', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-分页列表
export const acquire_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/acquire/findPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-删除 
export const acquire_batchRemove_request = async payload => {
    try {
        let res = await httpClient.post('/acquire/removeBatchByDeviceIds', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-获取终端设备型号列表(取value)
export const acquire_getAcquireModelList_request = async payload => {
    try {
        let res = await httpClient.post('/acquire/getAcquireModelList', payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表-根据ID获取信息
export const acquire_findInfoByDeviceId_request = async payload => {
    try {
        let res = await httpClient.get('/acquire/findInfoByDeviceId/'+payload.deviceId);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};


//采集表数据记录-数据导出
export const acquireData_exportData_request = async payload => {
    try {
        let res = await httpClient.get('/acquireData/export',{params:payload,timeout:0,responseType:'arraybuffer'});
        return res;
    } catch (e) {
        return Promise.reject(e);
    }
};

//采集表数据记录-分页列表
export const acquireData_getPageList_request = async payload => {
    try {
        let res = await httpClient.get('/acquireData/findPage',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取邮箱验证码
export const acquireData_getEmailVerificationCode_request = async payload => {
    try {
        let res = await httpClient.get('/accounts/getEmailVerificationCode',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//邮箱验证
export const acquireData_verifyEmail_request = async payload => {
    try {
        let res = await httpClient.post('/accounts/verifyEmail',payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//同意隐私协议
export const acquireData_acceptAgreement_request = async payload => {
    try {
        let res = await httpClient.post('/accounts/acceptPrivacyAgreement',payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//测试webhook地址是否有效
export const acquireData_checkWebhookIsValid_request = async payload => {
    try {
        let res = await httpClient.post('/push/checkWebhookIsValid',payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//分页查询项目webhook和短信告警配置
export const acquireData_findPageWebhookSmsAlarmConfig_request = async payload => {
    try {
        let res = await httpClient.get('/push/findPageWebhookSmsAlarmConfig',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//删除项目webhook和短信告警配置
export const acquireData_deleteWebhookSmsAlarmConfig_request = async payload => {
    try {
        let res = await httpClient.post('/push/removeWebhookSmsAlarmConfig',payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//新增或修改项目webhook和短信告警配置
export const acquireData_saveOrUpdateWebhookSmsAlarmConfig_request = async payload => {
    try {
        let res = await httpClient.post('/push/saveOrUpdateWebhookSmsAlarmConfig',payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//保存并发布隐私协议
export const acquireData_publishAgreement_request = async payload => {
    try {
        let res = await httpClient.post('/privacyAgreement/publishAgreement',payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//暂存协议内容
export const acquireData_saveTempAgreement_request = async payload => {
    try {
        let res = await httpClient.post('/privacyAgreement/saveTempAgreement',payload);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//查询暂存的协议
export const acquireData_searchTempAgreement_request = async payload => {
    try {
        let res = await httpClient.get('/privacyAgreement/searchTempAgreement',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//查询当前发布的协议
export const acquireData_searchNewestAgreement_request = async payload => {
    try {
        let res = await httpClient.get('/privacyAgreement/searchNewestAgreement',{params:payload});
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};

//获取项目负责接收告警的用户列表
export const acquireData_getProjectAlarmContactorList_request = async payload => {
    try {
        let res = await httpClient.get('/project/getProjectAlarmContactorList/'+payload.projectId);
        return res.data;
    } catch (e) {
        return Promise.reject(e);
    }
};






// WEBPACK FOOTER //
// ./src/api/api.js